import React from 'react';

import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

import buildStatusTableContents from './buildStatusTableContents';
import StatusTableTitle from './StatusTableTitle';
import StatusTableActions from '../StatusTable/StatusTableActions';

export default function useStatusTableWithTags() {
  const context = usePipelinePageContext();
  const { pipelineId } = context;
  const { writekey, lastDeployed, cluster } = context.pipeline;

  return {
    numberOfColumns: 2,
    data: buildStatusTableContents({ lastDeployed, pipelineId }),
    title: <StatusTableTitle writekey={writekey} cluster={cluster} />,
    actions: <StatusTableActions />,
  };
}
